<template>
  <ShareModal
    :show="shareModalVisible"
    :job-id="jobId"
    :has-share-users="hasShareUsers"
    :valid-users="validUsers"
    :is-linked="isLinked"
    :show-invite="showInvite"
    :company-name="companyName"
    @close="shareModalVisible = false"
  >
    <template #activator="{ props }">
      <v-btn
        variant="flat"
        class="mt-auto mb-auto share-button"
        color="primary"
        rounded="lg"
        :disabled="disabled"
        data-toggle="modal"
        data-target="#share-job-modal"
        :data-id="jobId"
        :data-draft="hasShareUsers && isLinked"
        v-bind="props"
        @click="shareModalVisible = true"
      >
        <template #prepend>
          <v-icon
            icon="material-symbols:arrow-top-right-rounded"
            size="20"
          />
        </template>
        Share
      </v-btn>
    </template>
  </ShareModal>
</template>
<script>
import ShareModal from './ShareModal.vue';

export default {
  name: 'ShareModalButton',
  components: { ShareModal },
  props: {
    jobId: { type: [String, Number], default: '' },
    validUsers: { type: Array, default: () => [] },
    isLinked: { type: Number, default: 0 },
    hasShareUsers: { type: Boolean, default: false },
    showInvite: { type: Boolean, default: false },
    companyName: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      shareModalVisible: false,
    };
  },
};
</script>

<style lang="less" scoped>
.share-button {
  text-transform: none;
}
</style>
